import React from "react";

/*eslint-disable */

declare const window: any;
const TitleComponent: React.FC = () => {
  return (
    <div className="title-politicas-component">POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES HYUNDAI COLOMBIA S.A.S.</div>
  );
};

export default TitleComponent;
